import { Flex, Text } from '@byecode/ui'
import React, { useMemo } from 'react'
import styled from 'styled-components'

const SCxContainer = styled.div``

const SCxParagraph = styled.div``

const SCxLabel = styled(Text)`
    color: var(--color-gray-700);
    font-size: var(--font-size-normal);
    font-weight: 500;
`

const SCxValue = styled(Text)`
    color: var(--color-gray-600);
    font-size: var(--font-size-normal);
    text-overflow: unset;
    white-space: break-spaces;
`

const SCxSpace = styled.div`
    width: 100%;
    height: 20px;
`

const SCxUl = styled.ul`
    padding: 0 24px;
`

const SCxLink = styled.a`
    text-decoration: none;
    color: var(--color-main);
    font-size: var(--font-size-normal);
    font-weight: 400;
    &:active {
        color: var(--color-main);
    }
`

export const PrivateTemplatePolicyCheck: React.FC = () => {
    return (
        <Flex alignItems="center">
            <Text inline color="var(--color-gray-500)" size={14} weight={400}>
                已阅读并同意
            </Text>
            <SCxLink href="https://byecodehelp.yuque.com/org-wiki-byecodehelp-zavfcl/oevich/bexs2e808a5p2ihb?singleDoc#" target="_blank">
                《启用私人模板规范》
            </SCxLink>
        </Flex>
    )
}

export const PrivateTemplatePolicy: React.FC = () => {
    return (
        <SCxContainer>
            <SCxValue>请检查模板中应避免包含以下几类内容</SCxValue>
            <SCxUl>
                <li>
                    <SCxValue>他人的隐私数据，例如手机号、姓名、住址、身份证号等</SCxValue>
                </li>
                <li>
                    <SCxValue>违反国家法律法规的内容</SCxValue>
                </li>
                <li>
                    <SCxValue>扰乱社会秩序的内容</SCxValue>
                </li>
                <li>
                    <SCxValue>涉及知识产权的内容</SCxValue>
                </li>
                <li>
                    <SCxValue>其他不良信息</SCxValue>
                </li>
            </SCxUl>
            <SCxSpace />
            <SCxValue>注意：应用集成中的所有账号信息会自动清空。</SCxValue>
        </SCxContainer>
    )
}
